<!--
  =====================================================================
  NOT FOUND PAGE - 404 ERROR PAGE
  =====================================================================
  
  Displays when a requested page or resource cannot be found.
  
  FEATURES:
  - User-friendly 404 error message
  - Links to navigate back to main sections
  - Responsive design
  
  =====================================================================
-->

<template>
  <main class="notfound-page">
    <div class="notfound-content">
      <img src="/images/logos/cassa_ufficiale1.jpg" alt="Logo Cassa" class="notfound-logo">
      <h1 class="notfound-title">404</h1>
      <h2 class="notfound-subtitle">Pagina non trovata</h2>
      <p class="notfound-text">
        La pagina che stai cercando potrebbe essere stata spostata, eliminata o non esiste.
      </p>
      <a href="/cassa/" class="notfound-link">
        Torna alla home
      </a>
    </div>
  </main>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'

/**
 * Block scrolling only when 404 page is visible
 * Removes global scroll block when component unmounts
 */
onMounted(() => {
  document.documentElement.style.height = '100vh'
  document.documentElement.style.overflow = 'hidden'
  document.body.style.height = '100vh'
  document.body.style.overflow = 'hidden'
  document.body.style.padding = '0'
  document.body.style.margin = '0'
})

onUnmounted(() => {
  document.documentElement.style.height = ''
  document.documentElement.style.overflow = ''
  document.body.style.height = ''
  document.body.style.overflow = ''
  document.body.style.padding = ''
  document.body.style.margin = ''
})
</script>

<style lang="scss" scoped>
@import '@/assets/styles/partials/variables';

/* ------------------------------------------------------------------
   Page container
------------------------------------------------------------------ */
.notfound-page {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: $space-3;
  background-color: #fff;
  box-sizing: border-box;
  overflow: hidden;
}

/* ------------------------------------------------------------------
   Content wrapper
------------------------------------------------------------------ */
.notfound-content {
  text-align: center;
  max-width: 600px;
}

/* ------------------------------------------------------------------
   Logo
------------------------------------------------------------------ */
.notfound-logo {
  max-width: 220px;
  height: auto;
  margin-bottom: $space-3;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

/* ------------------------------------------------------------------
   404 Number - Large and prominent
------------------------------------------------------------------ */
.notfound-title {
  font-size: clamp(3rem, 10vw, 8rem);
  font-weight: 300;
  color: $clr-tertiary;
  margin: 0 0 $space-1 0;
  line-height: 1;
}

/* ------------------------------------------------------------------
   Subtitle
------------------------------------------------------------------ */
.notfound-subtitle {
  font-size: clamp(1.5rem, 4vw, 2.5rem);
  font-weight: 300;
  color: $text-color;
  margin: 0 0 $space-2 0;
}

/* ------------------------------------------------------------------
   Description text
------------------------------------------------------------------ */
.notfound-text {
  font-size: $font-base;
  color: $clr-brand-gray;
  line-height: $line-height-base;
  margin: 0 0 $space-3 0;
}

/* ------------------------------------------------------------------
   Back to home link
------------------------------------------------------------------ */
.notfound-link {
  display: inline-block;
  padding: 0.75rem 2rem;
  background-color: $clr-tertiary;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 600;
  transition: all 0.3s ease;

  @media (hover: hover) {
    &:hover {
      background-color: darken($clr-tertiary, 10%);
      transform: translateY(-2px);
    }
  }
}

/* ------------------------------------------------------------------
   Responsive - Mobile
------------------------------------------------------------------ */
@media (max-width: 768px) {
  .notfound-page {
    padding: $space-2;
  }

  .notfound-subtitle {
    font-size: 1.5rem;
  }

  .notfound-text {
    font-size: $font-base-sm;
  }
}
</style>